import i18next from 'i18next';
import { smsAutoReplySettingsEnum } from 'infrastructure/enums';

export interface ISmsAutoReplySettingsTypeItem {
  key: string;
  name: string;
  conditionText?: string;
  smsText?: string;
  actionText?: string;
}

export const smsAutoReplySettingsDataSource =
  (): ISmsAutoReplySettingsTypeItem[] => {
    const dataSource: ISmsAutoReplySettingsTypeItem[] = [
      {
        key: smsAutoReplySettingsEnum.RPM,
        name: i18next.t('smsAutoReplySettings.rpm'),
        conditionText: i18next.t('smsAutoReplySettings.rpmCondition'),
        smsText: i18next.t('smsAutoReplySettings.rpmSms'),
      },
      {
        key: smsAutoReplySettingsEnum.SETUP,
        name: i18next.t('smsAutoReplySettings.setup'),
        conditionText: i18next.t('smsAutoReplySettings.setupCondition'),
        smsText: i18next.t('smsAutoReplySettings.setupSms'),
        actionText: i18next.t('smsAutoReplySettings.setupAction'),
      },
      {
        key: smsAutoReplySettingsEnum.STRIPS,
        name: i18next.t('smsAutoReplySettings.strips'),
        conditionText: i18next.t('smsAutoReplySettings.stripsCondition'),
        smsText: i18next.t('smsAutoReplySettings.stripsSms'),
      },
      {
        key: smsAutoReplySettingsEnum.BATTERIES,
        name: i18next.t('smsAutoReplySettings.batteries'),
        conditionText: i18next.t('smsAutoReplySettings.batteriesCondition'),
        smsText: i18next.t('smsAutoReplySettings.batteriesSms'),
      },

      {
        key: smsAutoReplySettingsEnum.NUMBER_80,
        name: i18next.t('smsAutoReplySettings.number_80'),
        conditionText: i18next.t('smsAutoReplySettings.80Condition'),
        smsText: i18next.t('smsAutoReplySettings.80Sms'),
      },
      {
        key: smsAutoReplySettingsEnum.NUMBER_81,
        name: i18next.t('smsAutoReplySettings.number_81'),
        conditionText: i18next.t('smsAutoReplySettings.81Condition'),
        smsText: i18next.t('smsAutoReplySettings.81Sms'),
        actionText: i18next.t('smsAutoReplySettings.81Action'),
      },
      {
        key: smsAutoReplySettingsEnum.NUMBER_82,
        name: i18next.t('smsAutoReplySettings.number_82'),
        conditionText: i18next.t('smsAutoReplySettings.82Condition'),
        smsText: i18next.t('smsAutoReplySettings.82Sms'),
        actionText: i18next.t('smsAutoReplySettings.82Action'),
      },
      {
        key: smsAutoReplySettingsEnum.NUMBER_83,
        name: i18next.t('smsAutoReplySettings.number_83'),
        conditionText: i18next.t('smsAutoReplySettings.83Condition'),
        smsText: i18next.t('smsAutoReplySettings.83Sms'),
        actionText: i18next.t('smsAutoReplySettings.83Action'),
      },
      {
        key: smsAutoReplySettingsEnum.NUMBER_90,
        name: i18next.t('smsAutoReplySettings.number_90'),
        conditionText: i18next.t('smsAutoReplySettings.90Condition'),
        smsText: i18next.t('smsAutoReplySettings.90Sms'),
      },
      {
        key: smsAutoReplySettingsEnum.NUMBER_91,
        name: i18next.t('smsAutoReplySettings.number_91'),
        conditionText: i18next.t('smsAutoReplySettings.91Condition'),
        smsText: i18next.t('smsAutoReplySettings.91Sms'),
        actionText: i18next.t('smsAutoReplySettings.91Action'),
      },
      {
        key: smsAutoReplySettingsEnum.NUMBER_92,
        name: i18next.t('smsAutoReplySettings.number_92'),
        conditionText: i18next.t('smsAutoReplySettings.92Condition'),
        smsText: i18next.t('smsAutoReplySettings.92Sms'),
        actionText: i18next.t('smsAutoReplySettings.92Action'),
      },
      {
        key: smsAutoReplySettingsEnum.NUMBER_93,
        name: i18next.t('smsAutoReplySettings.number_93'),
        conditionText: i18next.t('smsAutoReplySettings.93Condition'),
        smsText: i18next.t('smsAutoReplySettings.93Sms'),
        actionText: i18next.t('smsAutoReplySettings.93Action'),
      },
      {
        key: smsAutoReplySettingsEnum.BINGO,
        name: i18next.t('smsAutoReplySettings.bingo_winning_card'),
        conditionText: i18next.t(
          'smsAutoReplySettings.bingoWinningCardCondition',
        ),
        smsText: i18next.t('smsAutoReplySettings.bingoWinningCardSms'),
        actionText: i18next.t('smsAutoReplySettings.bingoWinningCardAction'),
      },
      {
        key: smsAutoReplySettingsEnum.BINGO_NUMBER,
        name: i18next.t('smsAutoReplySettings.bingo_number'),
        conditionText: i18next.t('smsAutoReplySettings.bingoNumberCondition'),
        actionText: i18next.t('smsAutoReplySettings.bingoNumberAction'),
      },
      {
        key: smsAutoReplySettingsEnum.CALL_ME,
        name: i18next.t('smsAutoReplySettings.call_me'),
        conditionText: i18next.t('smsAutoReplySettings.callMeCondition'),
        smsText: i18next.t('smsAutoReplySettings.callMeSms'),
        actionText: i18next.t('smsAutoReplySettings.callMeAction'),
      },
      {
        key: smsAutoReplySettingsEnum.CALL_ME_ES,
        name: i18next.t('smsAutoReplySettings.call_me_es'),
        conditionText: i18next.t('smsAutoReplySettings.callMeEsCondition'),
        smsText: i18next.t('smsAutoReplySettings.callMeEsSms'),
        actionText: i18next.t('smsAutoReplySettings.callMeEsAction'),
      },
    ];

    return dataSource;
  };
